export const parseUserRolesResponse = (data: unknown) => {
  if (Array.isArray(data)) {
    return {
      isInactive: false,
      roles: data,
    };
  }

  const payload =
    data && typeof data === "object"
      ? (data as { active?: boolean; roles?: string[] })
      : {};

  return {
    isInactive: payload.active === false,
    roles: Array.isArray(payload.roles) ? payload.roles : [],
  };
};
